function sumaCantidades(array){
    let suma = [];
    
    array.map(e => {    //rescatamos todas las cantidades en un array
        suma.push(parseInt(e.quantity))
      });
      let total = suma.reduce((anterior, actual) => { // sumamos todos los elementos del array
        return anterior + actual
      }, 0)

      return total    

}

function sumaCantidadesPresupuesto(array){
    let suma = [];
    
    array.map(e => {    //rescatamos todas las cantidades en un array
        suma.push(parseInt(e.presupuesto))
      });
      let total = suma.reduce((anterior, actual) => { // sumamos todos los elementos del array
        return anterior + actual
      }, 0)

      return total    

}

function sumaPrecios(array){
  let suma = [];
  
  array.map(e => {    //rescatamos todas las cantidades en un array
      suma.push(parseInt(e.price))
    });
    let total = suma.reduce((anterior, actual) => { // sumamos todos los elementos del array
      return anterior + actual
    }, 0)

    return total    

}

function sumaTotalImporte(array){
  let suma = [];
  
  array.map(e => {    //rescatamos todas las cantidades en un array
      suma.push(parseInt(e.totalPrice))
    });
    let total = suma.reduce((anterior, actual) => { // sumamos todos los elementos del array
      return anterior + actual
    }, 0)

    
    return total    

}

function sumaTotalImportePresupuesto(array){
  let suma = [];
  console.log(array);
  
  
  array.map(e => {    //rescatamos todas las cantidades en un array
    let numeros = isNaN(e.totalPricePresupuesto) ? "no es un numero" : "es un numero";
      console.log(numeros);  
    console.log(e.totalPricePresupuesto);
      suma.push(e.totalPricePresupuesto)
      
    });
    console.log(suma);
    
    let total = suma.reduce((anterior, actual) => { // sumamos todos los elementos del array
      return anterior + actual
    }, 0)

    
    return total    

}

module.exports = {
  sumaCantidades,
  sumaPrecios,
  sumaTotalImporte,
  sumaCantidadesPresupuesto,
  sumaTotalImportePresupuesto
}
